<template>
  <el-form
    :model="editForm"
    ref="editForm"
    :rules="rules"
    label-width="130px"
    :hide-required-asterisk="false"
  >
    <el-row>
      <el-col :span="12">
        <el-form-item label="项目" prop="xmmc">
          <el-input
            show-word-limit
            placeholder=""
            v-model="editForm.xmmc"
            disabled
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="上线日期" prop="onlineTime">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="editForm.onlineTime"
            style="width: 100%"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="position: relative">
        <el-form-item label="需求描述" prop="qdqrnr">
          <span><div id="wangEditor"></div></span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <el-form-item key="12" label="附件上传">
          <el-upload
            action="#"
            class="upload-demo"
            ref="upload"
            :headers="headers"
            :on-change="handleChange"
            :file-list="fileList"
            :auto-upload="false"
            multiple
          >
            <el-button type="primary" icon="el-icon-upload" plain
              >选择附件</el-button
            >
          </el-upload>
        </el-form-item>
      </el-col>
      <el-col :span="16" style="line-height: 40px">
        <div>(单个文件不能超过50M，支持所有扩展名)</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item label="上线步骤" prop="shr">
          <div class="table">
            <div class="table-header">
              <div>序号</div>
              <div>确认动作</div>
              <div>确认步骤</div>
              <div>
                操作
                <div @click="handleAddTd">+</div>
              </div>
            </div>
            <div class="table-body" v-if="sxbzList && sxbzList.length > 0">
              <div
                class="table-tr"
                v-for="(item, index) in sxbzList"
                :key="index"
              >
                <div class="table-td">{{ index + 1 }}</div>
                <div class="table-td">
                  <el-input size="mini" v-model="item.qrdz"></el-input>
                </div>
                <div class="table-td">
                  <el-input size="mini" v-model="item.qrbz"></el-input>
                </div>
                <div class="table-td del" @click="handleDelTd(item.id)">
                  删除
                </div>
              </div>
            </div>
            <div v-else class="table-none">暂无数据</div>
          </div>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12">
        <el-form-item label="清单确认负责人" prop="qdqrfzr" key="8">
          <treeselect
            v-model="editForm.qdqrfzr"
            placeholder="请选择员工"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="false"
            :normalizer="normalizer"
            style="width: 100%"
            size="small"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="清单确认日期" prop="qdqrrq">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="editForm.qdqrrq"
            style="width: 100%"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";
import {} from "@/api/question.js";
import moment from "moment";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { uploadQrFile, sxqrQuestion } from "@/api/question.js";
export default {
  computed: {
    ...mapGetters(["deptUser", "question", "user"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      rules: {
        onlineTime: [
          { required: true, message: "上线日期不能为空", trigger: "change" },
        ],
        qdqrfzr: [
          {
            required: true,
            message: "清单负责人度不能为空",
            trigger: "change",
          },
        ],
        qdqrrq: [
          {
            required: true,
            message: "清单确认日期不能为空",
            trigger: "change",
          },
        ],
        qdqrnr: [
          {
            required: true,
            message: "需求描述不能为空",
          },
        ],
      },
      editForm: {
        xmmc: null,
        onlineTime: moment(),
        xqms: null,
        qdqrfzr: null,
        qdqrrq: moment(),
        id: null,
        qdqrnr: null,
      },
      fileList: [],
      sxbzList: [],
      activeEditor: "0",
      parentDialog: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.$store.dispatch("common/fetchUserInfoAction");
    this.editForm.qdqrfzr = this.user.ygbh;
    this.editForm.xmmc = this.mxParams.xmmc;
    this.editForm.xqms = this.mxParams.xqms;
    this.editForm.id = this.mxParams.id;
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor`);

    editor = this.editorConfig(editor);

    // 创建编辑器
    this.editor = editor;
  },
  methods: {
    editorConfig(editor, height) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = height ? height : 300;
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      editor.config.onchange = function () {
        if (editor.txt.html() == "") {
          editor.txt.html("&nbsp");
        }
      };

      editor.create();
      return editor;
    },

    saveForm() {
      const onlineTime = moment(this.editForm.onlineTime).format("YYYYMMDD");
      const qdqrrq = moment(this.editForm.qdqrrq).format("YYYYMMDD");
      const qrbz = this.sxbzList;
      const params = {
        ...this.editForm,
        onlineTime,
        qdqrrq,
        qrbz,
      };
      sxqrQuestion(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$store.dispatch(
            "question/fetchQuestionListAction",
            this.question.questionList.params
          );
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    giveFather() {
      this.parentDialog = false;
    },

    handleAddTd() {
      const len = this.sxbzList.length;
      if (len == 0) {
        this.sxbzList.push({
          id: 1,
          qrbz: null,
          qrdz: null,
          eventId: this.mxParams.id,
        });
      } else {
        this.sxbzList.push({
          id: this.sxbzList[len - 1].id + 1,
          qrbz: null,
          qrdz: null,
          eventId: this.mxParams.id,
        });
      }
    },
    handleDelTd(id) {
      const temp = [];
      for (let i of this.sxbzList) {
        if (i.id != id) {
          temp.push(i);
        }
      }
      this.sxbzList = temp;
    },
    handleChange(file, fileList) {
      //验证上传文件的格式
      // const suffixReg = /(xls|xlsx|pdf|doc|docx|ppt|pptx)$/;
      // const point = file.name.lastIndexOf(".");
      // const suffix = file.name.substr(point + 1);
      // const isFile = suffixReg.test(suffix);
      // if (!isFile) {
      //   this.$message.error("请上传正确格式的文件 !");
      //   fileList.pop();
      //   return false;
      // }
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
      //验证上传文件重复
      //   let existFile = fileList
      //     .slice(0, fileList.length - 1)
      //     .find((f) => f.name === file.name);
      //   if (existFile) {
      //     this.$message.error("当前文件已经存在!");
      //     fileList.pop();
      //     return false;
      //   }
    },

    submitUpload() {
      this.editForm.qdqrnr = this.editor.txt.html();
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });

          if (fileLen > 0) {
            //上传文件
            form.append("id", this.mxParams.id);
            form.append("type", "上线确认");
            return new Promise((resolve, reject) => {
              uploadQrFile(form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("上传成功！");
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }).then((success) => {
              if (success.code == 0) {
                this.saveForm();
              }
            });
          } else if (fileLen == 0) {
            this.saveForm();
          } else {
            this.$message.error(res.msg);
            return false;
          }
        } else {
          this.hiddenDialog(true);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 40px;
}
.r {
  margin: 0 10px;
  .r_title {
    text-align: center;
    line-height: 40px;
    border-bottom: 2px solid #e4e7ed;
    box-sizing: border-box;
    height: 40px;
    margin-bottom: 15px;
  }
}
.zpsm-comment-item {
  margin-top: 15px;
  .top {
    display: flex;
    line-height: 30px;
    font-weight: bold;
    font-size: 15px;
    > div {
      margin-right: 15px;
    }
    > div:nth-of-type(1) {
      background-color: #8080ff;
      color: #fff;
      height: 30px;
      line-height: 30px;
      width: 30px;
      text-align: center;
      border-radius: 50%;
    }
  }
  .middle {
    line-height: 20px;
    color: #555;
    padding-left: 45px;
    margin: 10px 0;
  }
  .bottom {
    font-size: 12px;
    padding-left: 45px;
    color: #7f7f7f;
  }
}
.table {
  .table-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    > div {
      width: 15%;
      display: flex;
      justify-content: center;
      > div {
        color: #036eb8;
        padding: 0 10px;
        font-size: 25px;
        cursor: pointer;
      }
    }
    > div:nth-of-type(2) {
      width: 35%;
    }
    > div:nth-of-type(3) {
      width: 35%;
    }
  }
  .table-none {
    text-align: center;
    color: #999;
    margin: 10px 0;
  }
  .table-body {
    .table-tr {
      display: flex;
      height: 44px;
      line-height: 44px;
      text-align: center;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #f2f2f2;
      // border-left: 1px solid #f2f2f2;
      .table-td {
        display: flex;
        justify-content: center;
        width: 20%;
        padding: 0 15px;
        // border-right: 1px solid #f2f2f2;
      }
      .table-td:nth-of-type(2) {
        width: 35%;
      }
      .table-td:nth-of-type(3) {
        width: 35%;
      }
      .del {
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
</style>